import { useCallback, ReactNode } from "react";
import { recordSessionAction } from "../utils/fetchShareToken";
import { SessionContext } from "@juiceforward/narrative-player";

export function SessionProvider({
  sessionId,
  children,
}: {
  sessionId: string | null;
  children: ReactNode;
}) {
  const recordAction = useCallback(
    (actionType: string, metadata: Record<string, unknown> = {}) => {
      if (sessionId) {
        recordSessionAction(sessionId, actionType, metadata);
      }
    },
    [sessionId],
  );

  return (
    <SessionContext.Provider value={{ sessionId, recordAction }}>
      {children}
    </SessionContext.Provider>
  );
}
